module.exports = __webpack_public_path__ + "img/history-electric.31ade3c2.jpg";